export default function findDisclaimerHtml(fields) {
	// eslint-disable-next-line object-curly-newline
	return fields.reduce((accumulator, { type, value, key, id }, currentIndex) => {
		const found = (type === 'html')
			&& (value.match(/Disclaimer/i) || key.match(/^disclaimer/));
		if (found) {
			return {
				id,
				key,
				position: currentIndex,
			};
		}
		return accumulator;
	}, false);
}



// WEBPACK FOOTER //
// ./wp-content/plugins/core/assets/theme/js/src/forms/ai-enhanced-form-fields/source-form-locators/findDisclaimerHtml.js